import React    from 'react';
import Markdown from 'markdown-to-jsx';
import { get }  from 'object-path';

import * as css from './index.module.css';

const customTags = [{
    // keys, eg [W]
    regex        : /\[.*\]/,
    replacements : [
        [ /\[/g, '<span class="key">[' ],
        [ /\]/g, ']</span>' ]
    ]
}];

let debug;
let strings;

/**
 * Render text/markdown, unfortunately wraps text in a span
 * @param {string} path - path to string, eg intro.header
 * @param {object} [options]
 * @param {boolean} [options.md = true] - render as markdown, otherwise just text (default true)
 */
export function i18n(path, { md = true, errorText = true, fallback = true, doReplace = false } = {}) {
    if (!path) {
        return 'i18n() requires a path, eg i18n(\'intro.header\')';
    }

    let foundString = get(strings, path) ||
        (errorText ? `[[not found: ${path}]]` : undefined);

    if (!fallback && foundString === '[[]]') {
        foundString = undefined;
    }

    if (!md) {
        return foundString;
    }

    if (doReplace) {
        customTags.forEach(({ regex, replacements }) => {
            if (!regex.test(foundString)) {
                return;
            }

            replacements.forEach(([ find, replace ]) => {
                foundString = foundString.replace(find, replace);
            });
        });
    }

    if (debug) {
        return <Markdown data-i18n={path} className={css.debug}>{ foundString }</Markdown>;
    }

    return <Markdown>{ foundString }</Markdown>;
}

export function setStrings(_strings, _debug) {
    debug   = _debug;
    strings = _strings;
}
